const RenderIf = ({ render, children }) => (render ? children : null);
export default RenderIf;
